export default __webpack_public_path__ + "static/6840-398bfbe4eb2c497ce5bea0214ebfb1ab.jpg";